import Axios from 'axios'
import store from '@/store/store'
import Auth from '@/helpers/auth'

let fetchingToken = false
let subscribers = []

function getSubscriberOnToken (token) {
  subscribers = subscribers.filter(callback => callback(token))
}

function addSubscriber (callback) {
  subscribers.push(callback)
}

const axios = Axios.create({
  headers: {
    'Content-Type': 'application/json'
  }
})

// /* Set interceptor to refresh token */
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    const { config, response: { status } } = error
    const originalRequest = config

    if (status === 401) {
      console.log('401')
      if (!fetchingToken) {
        fetchingToken = true

        let token

        Auth
          .refreshToken(axios)
          .then(res => {
            token = res.data.token

            Auth.saveTokens(res.data)

            axios.defaults.headers.common['Authorization'] = `${token.type} ${token.value}`

            fetchingToken = false

            getSubscriberOnToken(token)
          })
          .catch(err => {
            console.log(err)
            Auth.logout()
          })

        const retryOriginalRequest = new Promise((resolve) => {
          addSubscriber(token => {
            originalRequest.headers.Authorization = `${token.type} ${token.value}`
            resolve(axios(originalRequest))
          })
        })
        return retryOriginalRequest
      }
    }
    return Promise.reject(error)
  })

/* Handle token auth */
const token = Auth.getToken()
if (token !== null) {
  axios.defaults.headers.common = {
    'Authorization': `${token.type} ${token.value}`
  }

  const user = Auth.getUser()

  if (user === null) {
    //  Get user from API
    axios
      .get(`${process.env.VUE_APP_API}/users/u`)
      .then(res => {
        Auth.saveUser(res.data.user)
        //  Populate store
        store.commit('users/saveCurrentUser', res.data.user)
      })
  } else {
    store.commit('users/saveCurrentUser', user)
  }
}

export default axios

// axios.interceptors.request.use((config) => {
//   // const token = store.getState().session.token
//   config.headers.This = 'That'
//   return config
// })
